import { IMdCmFields } from "../types/AppTypes";
import { MdEnableStatusEnum } from "../types/AppEnums";

//系统标识  测试和生产主数据标识区别
export const CLIENT_APP_CODE = "franchisee";

export const DEFAULT_PAGE_SIZE = 25;
export const DEFAULT_FIRST_PAGE_NUM = 1;
export const DEFAULT_REQUEST_TIMEOUT = 30000;

//API请求环境
const baseRequestUrl = {
	"DEV": "https://api.peijian88.cn",
	"STAGE": "https://api.beiben88.com",
	"TEST": "https://test-api-2.laoniuche.cn",
	// "TEST": "https://192.168.110.121:9059",
	"PROD": "https://api-2.yunhaogroup.com"
}

const baseWSRequestUrl = {
	DEV: "ws://test.franchisee.websocket.laoniuche.cn/yh-franchisee",
	PROD: "ws://franchisee-2.websocket.yunhaogroup.com/yh-franchisee",
	TEST: "ws://test.franchisee.websocket.laoniuche.cn/yh-franchisee",
	//TEST: "ws://127.0.0.1:9041/yh-franchisee",
}

//财务的请求环境
const baseFmsRequestUrl = {
	"TESTAPI": "https://test-api.laoniuche.cn",
	"DEV": "https://api.peijian88.cn",
	"TEST": "https://test-test-api-2.laoniuche.cn",
	"PROD": "https://api-2.yunhaogroup.com",
	"STAGE": "https://api.beiben88.com"
}
const baseCiRequestUrl = {
	TESTAPI: `https://test.api.yunhaochefu.com`,
	DEV: `https://test.api.yunhaochefu.com`,
	TEST: `https://test.api.yunhaochefu.com`,
	PROD: 'https://api.yunhaochefu.com',
	STAGE: 'https://test.api.yunhaochefu.com',

};

const baseWebsiteUrl = {
	TESTAPI: `https://test.yunhaochefu.com`,
	DEV: `https://test.yunhaochefu.com`,
	TEST: `https://test.yunhaochefu.com`,
	PROD: 'https://www.yunhaochefu.com',
	STAGE: 'https://www.yunhaochefu.com',

};


export const getBaseWSRequestUrl = () => {
	//自动选择环境
	//....
	const REACT_APP_ENV = process.env.REACT_APP_ENV as 'DEV' | 'TEST' | 'PROD'
	return baseWSRequestUrl[REACT_APP_ENV ?? 'DEV']
}

//根据环境变量自动获取请求地址
export const getBaseRequestUrl = () => {
	//自动选择环境
	//....
	const REACT_APP_ENV = process.env.REACT_APP_ENV as "DEV" | "TEST" | "PROD" | "STAGE";
	return baseRequestUrl[REACT_APP_ENV ?? "DEV"]
};
//根据环境变量自动获取请求地址
export const getBaseFmsRequestUrl = () => {
	const REACT_APP_ENV = process.env.REACT_APP_ENV as "DEV" | "TEST" | "PROD" | "STAGE" | "TESTAPI";
	return baseFmsRequestUrl[REACT_APP_ENV ?? "DEV"]
};
//根据环境变量自动获取请求地址
export const getBaseCiRequestUrl = () => {
	const REACT_APP_ENV = process.env.REACT_APP_ENV as "DEV" | "TEST" | "PROD" | "STAGE" | "TESTAPI";
	return baseCiRequestUrl[REACT_APP_ENV ?? "DEV"]
};

//服务器自定义错误码
export const INTERNAL_SERVER_ERROR_CODE = 500;
//token存储KEY值
export const TOKEN_KEY = "token";

//获取token
export const getToken = () => {
	return sessionStorage.getItem(TOKEN_KEY) ?? "default-token-str"
};

//存储token
export const setToken = (token: string) => {
	sessionStorage.setItem(TOKEN_KEY, token)
};
//通用字段定义
//通用字段定义
export const defaultMdCmParam: IMdCmFields = {
	sourceApp: "franchisee",
	sourceAuthKey: "",
	branch: "franchisee",
	ver: undefined,
	enable: MdEnableStatusEnum.ENABLE,
};

export const branchDs = [
	{ label: "财务分支", value: "fms" },
	{ label: "主分支", value: "main" },
]


//根据环境变量自动获取图片查看地址
export const getBaseImgLookUrl = (md5: string) => {
	// https://file-server.yunhaochefu.com/image/
	//自动选择环境
	// return `${getBaseRequestUrl()}/fsrv/fetch/${md5}?Authorization=${getToken()}`
	return `https://file-server.yunhaochefu.com/image/${md5}`
}

//根据环境变量自动获取图片上传地址
export const getBaseImgUploadUrl = () => {
	//自动选择环境
	// return `${getBaseRequestUrl()}/fsrv/upload_file?Authorization=${getToken()}`
	return `${getBaseCiRequestUrl()}/ci-file-server/upload/image_old`
}

//根据环境变量自动获取图片上传地址
export const getBaseUploadData = () => {
	return {
		appCode: CLIENT_APP_CODE,
		fileMode: 0,
	}
}


//根据环境变量自动获取云豪车服官网地址
export const getBaseWebsiteUrlUrl = () => {
	const REACT_APP_ENV = process.env.REACT_APP_ENV as "DEV" | "TEST" | "PROD" | "STAGE" | "TESTAPI";
	return baseWebsiteUrl[REACT_APP_ENV ?? "DEV"]
};

